"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var CssBaseline_1 = __importDefault(require("@material-ui/core/CssBaseline"));
function CssBaseline() {
    return jsx_runtime_1.jsx(CssBaseline_1.default, {}, void 0);
}
exports.default = CssBaseline;
//# sourceMappingURL=CssBaseline.js.map